export default __webpack_public_path__ + "static/chris-207398e5a45aaa8654fde8ddd62e93d1.png";